import EffectAmount from '@/roc/effects/EffectAmount';

class ProductionWorkforce extends EffectAmount
{
}

export default ProductionWorkforce;
